import classnames from "classnames";
import React, { FC, memo } from "react";

import { testAttr } from "@/browser";

import { flexAlignClass, flexJustifyClass } from "../../../Style";
import { Text } from "../../../Typography";
import { IColumnConfig } from "../../types";
import { getColumnStyle } from "../../utils";

export interface IHeaderCellProps extends Omit<IColumnConfig, "align"> {
  className?: string;
}

const HeaderCellComponent: FC<IHeaderCellProps> = props => {
  const { className, HeaderComponent, header, justify = "flex-start", ...rest } = props;

  const style = getColumnStyle(props);
  const classNames = classnames(
    "data-table__header-cell",
    flexAlignClass("center"),
    flexJustifyClass(justify),
    className,
  );

  const testableProps = testAttr(rest, { sufix: "data-table__header-cell" });

  return (
    <div style={style} className={classNames} {...testableProps}>
      {HeaderComponent ? (
        <HeaderComponent header={header} />
      ) : (
        <Text size="sm" ellipsis>
          {header}
        </Text>
      )}
    </div>
  );
};

export const HeaderCell = memo(HeaderCellComponent);
